import { useQuery } from '@apollo/client';
import React, { ReactNode } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { AliasResolution, aliasRouteFromPath, canonicalPublicPath } from './canonicalSlugRedirectUtils';
import { SLUG_ALIAS_RESOLUTION } from './slugAliasResolutionQuery';

const CanonicalSlugRedirect = ({ children }: { children: ReactNode }): React.ReactElement => {
  const location = useLocation();
  const aliasRoute = aliasRouteFromPath(location.pathname);
  const { data } = useQuery<AliasResolution>(SLUG_ALIAS_RESOLUTION, {
    variables: { slug: aliasRoute?.slug },
    skip: !aliasRoute,
    fetchPolicy: 'network-only',
  });

  const canonicalPath = aliasRoute ? canonicalPublicPath(aliasRoute, data) : null;
  const target = canonicalPath && aliasRoute ? `${canonicalPath}${aliasRoute.rest}` : null;
  if (target && target !== location.pathname) {
    return <Redirect to={{ pathname: target, search: location.search, hash: location.hash }} />;
  }

  return <>{children}</>;
};

export default CanonicalSlugRedirect;
